<script setup>
// import { Link } from '@inertiajs/vue3'
import TextareaInput from '@/Shared/TextareaInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import { useForm } from '@inertiajs/vue3'
import MultiselectInput from '@/Shared/MultiselectInput.vue'
import { ref, watch } from 'vue'
import Portrait from '@/Shared/Portrait.vue'
import Icon from '@/Shared/Icon.vue'

defineProps({
  players: {
    type: Array,
    default: () => []
  },
  levels: {
    type: Array,
    default: () => []
  }
})

const player = ref(null)

let form = useForm({
  player_id: null,
  levels: [],
  observations: ''
})

watch(
  () => player.value,
  (value) => {
    form.player_id = value.id
  }
)

function store() {
  form.post('/students/store')
}

const breadcrumbs = [
  { label: 'Clases' },
  { label: 'Alumnos', href: '/students' },
  { label: 'Crear' }
]
</script>

<template>
  <Portrait
    title="Crear alumno"
    subtitle="Asigna un jugador como alumno del club"
    :breadcrumbs="breadcrumbs"
    :footer-actions="true"
  >
    <form class="space-y-6" @submit.prevent="store">
      <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6 rounded-r-md">
        <div class="flex">
          <div class="flex-shrink-0">
            <Icon name="InformationCircle" class="h-5 w-5 text-blue-400" />
          </div>
          <div class="ml-3">
            <p class="text-sm text-blue-700">
              Para crear un alumno, primero debes seleccionar un jugador existente y asignarle los
              niveles correspondientes.
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-6">
        <MultiselectInput
          v-model="player"
          :error="form.errors.player_id"
          :options="players"
          :multiple="false"
          class="w-full"
          label="Jugador"
          input-label="fullname"
          track-by="id"
        />

        <MultiselectInput
          v-model="form.levels"
          :options="levels"
          :error="form.errors.levels"
          class="w-full"
          label="Niveles"
          input-label="name"
          track-by="name"
        />

        <TextareaInput
          v-model="form.observations"
          :error="form.errors.observations"
          label="Observaciones"
          placeholder="Añade notas o comentarios sobre este alumno"
        />
      </div>
    </form>

    <template #footer>
      <div class="flex items-center justify-end w-full">
        <LoadingButton :loading="form.processing" class="btn-indigo" @click="store">
          Crear
        </LoadingButton>
      </div>
    </template>
  </Portrait>
</template>
